import React, {useState, useEffect} from "react";
import "./Header.css";
import {Container, Nav, Navbar, NavDropdown, Offcanvas, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCircle, faClipboardList, faGauge, faMagnifyingGlass, faUser, faUserAlt, faMoon, faSun, faRightFromBracket
} from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as Logo } from "./logo.svg";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {faClock} from "@fortawesome/free-regular-svg-icons";
import TimezoneSelector from "../../TimezoneSelector";
import { useAuth } from "../../../../../contexts/AuthContext";


function Header({onSearch, bondTimezone = null, bondTimezones = []}) {
    const { user, logout } = useAuth();

    const [theme, setTheme] = useState(() => {
        // Initialize theme from localStorage or default to dark
        return localStorage.getItem('theme') || 'dark';
    });

    // Apply theme on mount and when theme changes
    useEffect(() => {
        document.documentElement.setAttribute('data-bs-theme', theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    function toggleTheme() {
        setTheme(prevTheme => prevTheme === 'dark' ? 'light' : 'dark');
    }


    return (<><Navbar key={false} expand={false} className="bg-body-tertiary mb-2">
        <Container fluid className={"justify-content-between"}>
            <div className="d-flex align-items-center">
                <Button variant="outline" onClick={onSearch}>
                    <Logo width={30} height={30} className={""}/>
                </Button>
                <span className="navbar-brand mb-0 h1 ms-2">
                    Bond{" "}
                    <NavDropdown
                        title="Dashboard"
                        id="tool-switcher-dropdown"
                        className="tool-switcher-dropdown d-inline-block"
                    >
                        <NavDropdown.Item active>
                            Dashboard
                        </NavDropdown.Item>
                        <NavDropdown.Item
                            onClick={() => {
                                window.location.hash = '#/palantir/';
                            }}
                        >
                            Palantir
                        </NavDropdown.Item>
                    </NavDropdown>
                </span>
            </div>
            <div className="d-flex align-items-center">
                <TimezoneSelector variant="badge" bondTimezone={bondTimezone} bondTimezones={bondTimezones} />
                <Dropdown align="end" className="ms-2">
                    <Dropdown.Toggle variant="outline-secondary" id="dropdown-user">
                        <FontAwesomeIcon icon={faUserAlt} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.ItemText>
                            <div className="px-2 py-1">
                                {user?.name && <div className="fw-bold">{user.name}</div>}
                                <div className={user?.name ? "text-muted small" : ""}>{user?.email || 'Loading...'}</div>
                            </div>
                        </Dropdown.ItemText>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={toggleTheme}>
                            <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} className="me-2" />
                            Switch to {theme === 'dark' ? 'Light' : 'Dark'} Theme
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={logout}>
                            <FontAwesomeIcon icon={faRightFromBracket} className="me-2" />
                            Logout
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <Navbar.Offcanvas
                id={`navbarHeaderExpand`}
                placement="start"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title id={`offcanvasNavbarLabel-expand`}>
                        <Logo width={30} height={30} className={"me-2"}/>Bond Dashboard
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form className="d-flex">
                        <Form.Control
                            type="search"
                            placeholder="User email or Bond ID"
                            className="me-2"
                            aria-label="Search"
                        />
                        <Button variant="outline-success"><FontAwesomeIcon icon={faMagnifyingGlass}/></Button>
                    </Form>
                    <Nav className="">
                        <Nav.Link href="#action1"><FontAwesomeIcon icon={faGauge}/> Dashboard</Nav.Link>
                        <Nav.Link href="#action2"><FontAwesomeIcon icon={faClipboardList}/> Reports</Nav.Link>
                        <NavDropdown
                            title={<span><FontAwesomeIcon icon={faClock} className={"me-2"}/>History</span>}
                            id={`offcanvasNavbarDropdown-expand`}
                        >
                            <NavDropdown.Item href="#action4">
                                <FontAwesomeIcon icon={faCircle} className={"me-2"}/>ZZBL41858
                            </NavDropdown.Item>
                            <NavDropdown.Divider/>

                            <NavDropdown.Item href="#action4">
                                <FontAwesomeIcon icon={faCircle} className={"me-2"}/>ZPXXL41890
                            </NavDropdown.Item>
                            <NavDropdown.Divider/>
                            <NavDropdown.Item href="#action5">
                                <FontAwesomeIcon icon={faUser} className={"me-2"}/>guy@gmail.com
                            </NavDropdown.Item>
                            <NavDropdown.Divider/>

                            <NavDropdown.Item href="#action4">
                                <FontAwesomeIcon icon={faCircle} className={"me-2"}/>ZXBL41858
                            </NavDropdown.Item>
                            <NavDropdown.Divider/>

                            <NavDropdown.Item href="#action4">
                                <FontAwesomeIcon icon={faCircle} className={"me-2"}/>ZPBL41858
                            </NavDropdown.Item>
                            <NavDropdown.Divider/>
                            <NavDropdown.Item href="#action5">
                                <FontAwesomeIcon icon={faUser} className={"me-2"}/>joao+test@olibra.io
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Nav>

                </Offcanvas.Body>
            </Navbar.Offcanvas>
        </Container>
    </Navbar>
    </>);
}

export default Header;
